export default [
  {
    title: 'breadcrumb.master',
    route: 'list-master',
    icon: '',
    resource: 'master',
    action: 'read',
  },
]
